import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import { discussionClient } from "../../AxiosClient";
import FormControl from "@material-ui/core/FormControl";
import TaxonomyTree from "../taxonomy/TaxonomyTree";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import ItemExpertQuestionTemplate from "../list-item/ItemExpertQuestionTemplate";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import SwipeableViews from "react-swipeable-views";
import DisplayExpertQuestionTemplate from "./DisplayExpertQuestionTemplate";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputLabel from "@material-ui/core/InputLabel";
import Divider from "@material-ui/core/Divider";
import { Virtuoso } from "react-virtuoso";
import { withRouter } from "react-router-dom";
import { withSnackbar } from "notistack";
import CreateExpertQuestionTemplate from "./CreateExpertQuestionTemplate";
import e from "cors";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
class ExpertQuestionMaintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      taxonomyId: null,
      taxonomyIdCreate: null,
      taxonomyName: "",
      treeOnly: true,
      urgency: "MEDIUM",
      activeStep: 0,
      selectedTemplate: {},
      createTemplate: {},
      editData: null,
    };
  }
  render() {
    const GenerateItem = (index) => {
      return (
        <ItemExpertQuestionTemplate
          expert={this.props.expert}
          selectTemplate={this.selectTemplate}
          data={this.state.data[index]}
          removeTemplate={this.removeTemplate}
          edit={this.props.expert}
          openEdit={(data) => {
            this.setState({ activeStep: 2, editData: data });
          }}
        />
      );
    };
    const { classes, t, forwardedRef } = this.props;
    return (
      <div
        style={{
          overflow: "auto",
          padding: "0 10px 0 10px",
          height: "100%",
          flex: 1,
          backgroundColor: "#eae0d7",
          backgroundImage: "url('../../images/background.svg')",
        }}
      >
        <Paper style={{ marginTop: 20, margin: 10 }}>
          <DialogContent>
            <SwipeableViews
              style={{ height: "100%" }}
              index={this.state.activeStep}
              slideClassName="swipeable-slide"
              slideStyle={{ overflowX: "hidden" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                {this.state.activeStep === 0 && (
                  <>
                    <Typography variant="h5" style={{ paddingTop: 10 }}>
                      {!this.props.expert
                        ? t("ask_an_expert")
                        : t("expert_question_template_maintenance_title")}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {t("ask_an_expert_subheader")}
                    </Typography>
                    <div style={{ display: "flex", flex: 1 }}>
                      <FormControl
                        component="fieldset"
                        style={{ flex: 0.5, marginRight: 10, height: "100%" }}
                      >
                        <TaxonomyTree
                          includeRoledUsers
                          allowedSelections={["taxonomy"]}
                          onNodeSelected={this.onTaxonomyNodeChange}
                          noElevate
                          treeType="expertQuestions"
                        />
                      </FormControl>
                      <Divider orientation="vertical" />
                      <div style={{ flex: 1 }}>
                        {this.state.data.length > 0 ? (
                          <div
                            style={{ height: "90%", padding: 10 }}
                            id="templates-list"
                          >
                            <Typography gutterBottom variant="h6">
                              {t("templates_for_node_header", {
                                taxonomyName: this.state.taxonomyName,
                              })}
                            </Typography>
                            <Virtuoso
                              style={{ width: "100%", height: "90%" }}
                              overscan={10}
                              totalCount={this.state.data.length}
                              itemContent={GenerateItem}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              flex: 1,
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              height: "100%",
                            }}
                          >
                            {this.state.taxonomyId ? (
                              <Typography>
                                {t("no_templates_for_node", {
                                  taxonomyName: this.state.taxonomyName,
                                })}
                              </Typography>
                            ) : (
                              <Typography>
                                {t("select_node_to_see_templates")}
                              </Typography>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                {this.state.activeStep === 1 && (
                  <>
                    <Typography variant="h6">
                      {t("create_expert_question_header")}
                    </Typography>
                    <Typography variant="body2">
                      {t("create_expert_question_subheader")}
                    </Typography>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <KpsTextField
                        id="question-title"
                        fullWidth
                        onChange={(e) =>
                          this.setState({
                            selectedTemplate: {
                              ...this.state.selectedTemplate,
                              title: e.target.value,
                            },
                          })
                        }
                        value={this.state.selectedTemplate.title || ""}
                        label={<Trans i18nKey="expert_question_title" />}
                      />
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-label">
                        <Trans i18nKey="global_visibility" />
                      </InputLabel>
                      <Select
                        value={this.props.visibility}
                        id="question-visibility"
                        onChange={(event) =>
                          this.setState({ visibility: event.target.value })
                        }
                      >
                        <MenuItem value={"EXPERT_ONLY"}>
                          <Trans i18nKey="expert_only" />
                        </MenuItem>
                        <MenuItem value={"PUBLIC_VIEW_ONLY"}>
                          <Trans i18nKey="public_view" />
                        </MenuItem>
                        <MenuItem value={"PUBLIC_VIEW_AND_WRITE"}>
                          <Trans i18nKey="public_view_and_write" />
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <InputLabel>
                        <Trans i18nKey="global_expert_question_urgency" />
                      </InputLabel>
                      <Select
                        value={this.state.urgency}
                        id="question-urgency"
                        onChange={(event) =>
                          this.setState({ urgency: event.target.value })
                        }
                      >
                        <MenuItem value={"LOW"}>
                          <Trans i18nKey="expert_question_urgency_low" />
                        </MenuItem>
                        <MenuItem value={"MEDIUM"}>
                          <Trans i18nKey="expert_question_urgency_medium" />
                        </MenuItem>
                        <MenuItem value={"HIGH"}>
                          <Trans i18nKey="expert_question_urgency_high" />
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <div
                      style={{
                        border: "1px dashed rgba(0,0,0,0.3)",
                        padding: 20,
                        marginTop: 10,
                      }}
                    >
                      <Typography variant="h5">
                        {this.state.selectedTemplate.title}
                      </Typography>
                      {this.state.selectedTemplate &&
                        this.state.selectedTemplate.templateJson &&
                        this.state.selectedTemplate.templateJson.map(
                          (section) => (
                            <DisplayExpertQuestionTemplate
                              changeValue={this.changeValue}
                              data={section}
                            />
                          )
                        )}
                    </div>
                  </>
                )}
              </div>
              <div>
                {this.state.activeStep === 2 && (
                  <CreateExpertQuestionTemplate
                    edit={this.state.editData ? true : false}
                    editData={this.state.editData}
                    taxonomyIdCreate={(id) =>
                      this.setState({ taxonomyIdCreate: id })
                    }
                    onTemplateChange={(template) =>
                      this.setState({ createTemplate: template })
                    }
                  />
                )}
              </div>
            </SwipeableViews>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.activeStep === 0}
              onClick={() => this.setState({ activeStep: 0, editData: null })}
              color="primary"
            >
              <Trans i18nKey="global_back" />
            </Button>
            <Button
              disabled={
                (!this.props.expert || this.state.treeOnly) &&
                (this.state.activeStep !== 1 ||
                  !this.state.selectedTemplate.title ||
                  !this.state.visibility)
              }
              onClick={
                !this.props.expert
                  ? this.createExpertQuestion
                  : this.state.activeStep === 2
                    ? this.createTemplate
                    : this.openCreateExpertQuestionTemplate
              }
              color="primary"
              id="create-expert-question-button"
            >
              {this.state.activeStep === 2 ? (
                <Trans i18nKey="global_save" />
              ) : (
                <Trans i18nKey="global_create" />
              )}
            </Button>
          </DialogActions>
        </Paper>
      </div>
    );
  }
  openCreateExpertQuestionTemplate = () => {
    this.setState({ activeStep: 2 });
  };

  removeTemplate = (id) => {
    let dataCopy = [...this.state.data];
    let itemIndex;
    dataCopy.map((item, index) => {
      if (item.id === id) {
        itemIndex = index;
      }
    });
    dataCopy.splice(itemIndex, 1);
    this.setState({ data: dataCopy });
  };
  changeValueMap = (value, id, array) => {
    array.map(
      (currentData) =>
        currentData.id === id
          ? (currentData.value = value)
          : this.changeValueMap(value, id, currentData.expandedFrom)
    );
  };

  changeValue = (value, id) => {
    let tempArray = [...this.state.selectedTemplate.templateJson];
    this.changeValueMap(value, id, tempArray);
    this.setState({
      selectedTemplate: {
        ...this.state.selectedTemplate,
        templateJson: tempArray,
      },
    });
  };
  selectTemplate = (template) => {
    let tempTemplate = { ...template };
    tempTemplate.templateJson = JSON.parse(tempTemplate.templateJson);
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.title
    ) {
      tempTemplate.title = this.props.location.state.title;
    } else {
      tempTemplate.title = "";
    }
    let count = 1;
    tempTemplate.templateJson.map((item) => {
      item.id = count;
      count++;
    });
    this.setState({ selectedTemplate: tempTemplate, activeStep: 1 });
  };

  onTaxonomyNodeChange = (taxNode) => {
    // treeOnly nodes are visible but only to support their children which the user
    // will have permissions on somewhere.  So we don't give the option to create a question on such nodes
    this.setState({
      taxonomyId: taxNode.id,
      taxonomyName: taxNode.name,
      treeOnly: taxNode.treeOnly === true,
    });
    if (!taxNode.treeOnly) {
      this.getTemplates(taxNode.id);
    } else {
      this.setState({ data: [] });
    }
  };
  createExpertQuestion = () => {
    let tempTemplate = { ...this.state.selectedTemplate };
    tempTemplate.templateJson = JSON.stringify(tempTemplate.templateJson);
    let expertQuestion = {};
    expertQuestion.expertQuestionVisibility = this.state.visibility;
    expertQuestion.ExpertQuestionStatus = "OPEN";
    expertQuestion.urgency = this.state.urgency;
    expertQuestion.title = tempTemplate.title;
    let entry = {};
    entry.text = tempTemplate.templateJson;
    let expertQuestionEntryDTO = {};
    expertQuestionEntryDTO.entryDTO = entry;
    expertQuestionEntryDTO.expertQuestionDTO = expertQuestion;
    discussionClient
      .post(
        `taxonomynode/${this.state.taxonomyId}/expertquestion/`,
        expertQuestionEntryDTO
      )
      .then((res) => {
        this.props.enqueueSnackbar(
          this.props.t("expert_question_has_been_created_snackbar", {
            title: this.state.selectedTemplate.title,
          }),
          { variant: "success" }
        );
        this.setState({ activeStep: 0 });
      })
      .catch(() => {
        this.props.enqueueSnackbar(
          this.props.t("expert_question_creation_error_occurred", {
            variant: "error",
          })
        );
      });
  };
  getTemplates = (id) => {
    discussionClient
      .get(`taxonomynode/${id}/expertquestiontemplate/`)
      .then((res) => {
        this.setState({ data: res.data.content });
      });
  };
  clearValues = (array) => {
    array.map((item) => {
      item.value = null;
      item.id = null;
      this.clearValues(item.expandedFrom);
    });
  };
  createTemplate = () => {
    let copyData = JSON.parse(JSON.stringify(this.state.createTemplate));
    let templateJson = copyData.templateJson;
    if (!this.state.editData) {
      this.clearValues(templateJson);
      copyData.templateJson = JSON.stringify(templateJson);
      discussionClient
        .post(
          `taxonomynode/${this.state.taxonomyIdCreate}/expertquestiontemplate/`,
          copyData
        )
        .then((res) => {
          this.props.enqueueSnackbar(
            this.props.t("template_has_been_created_snackbar"),
            { variant: "success" }
          );
        })
        .catch(() => {
          this.props.enqueueSnackbar("", { variant: "error" });
        });
      this.setState({ activeStep: 0, data: [] });
    } else {
      copyData.templateJson = JSON.stringify(copyData.templateJson);
      discussionClient
        .patch(`expertquestiontemplate/${this.state.editData.id}/`, copyData)
        .then((res) => {
          this.props.enqueueSnackbar(
            this.props.t("template_has_been_edited_snackbar"),
            { variant: "success" }
          );
        })
        .catch(() => {
          this.props.enqueueSnackbar("", { variant: "error" });
        });
      this.setState({ activeStep: 0, data: [] });
    }
  };
}

export default withTranslation()(
  withStyles(styles)(withSnackbar(withRouter(ExpertQuestionMaintenance)))
);
